import styled from 'styled-components';

const ListItemIcon = styled.span.attrs((props) => ({
  className: props.className,
}))`
  display: block;
  height: 17px;
  position: relative;
  width: 32px;
  ${(props) => props.theme.breakpoints.up('md')} {
    background-position: right center;
  }
`;

export default ListItemIcon;
